import { BaseModel } from "./BaseModel";
import IAuthorizationData, {
  IPlayerConfig,
  IGameConfig,
} from "../server/data/IAuthorizationData";
import ISpinData from "../server/data/ISpinData";
import { IMoneyFieldConfig } from "../../src/views/AbstractMoneyField";
import IAppGameConfig from "./IAppGameConfig";
import KeyboardManager, { Key } from "../utils/KeyboardManager";

class GameModel extends BaseModel<IAuthorizationData> {
  public playerConfig: IPlayerConfig = null;
  public authorizationToken: string = "";
  public operatorToken: string = "";
  public playerToken: string = "";
  public sessionID: string = "";
  public apiKey: string = "";
  public clock: boolean;
  public _gameConfig: any;
  public incompleteSpinsData: ISpinData = null;
  public currency: string;
  public lobbyURL: string = "";
  public lang: string = "en";
  public mobile: boolean;
  public android: boolean;
  public iOS: boolean;
  public symbolMap: Map<string, number>;
  public version: number = 0;
  public serverGameConfig: IGameConfig = null;
  public urlParams: any;
  public mode: string = "dev";
  public replayToken: string = "";
  public gameName: string = "";
  public country: string;
  public defaultCurrencyFormat: IMoneyFieldConfig = null;
  public isDemo = true;
  public homeUrl: string;
  public hasRealityCheck: boolean = false;
  public forceRealityCheck: boolean = false;
  public isWinSkipped: boolean = false;
  public layout: number[] = [];

  public regulation: string;
  public jurisdiction: string;
  public inBonusFeature: boolean = false;
  public restoreVersion: number = 1;
  public restoreData: any = null;
  public turboSpin: boolean = false;
  public spaceToSpin: boolean = true;
  public shouldPauseGame: boolean = false;
  public shouldStopAutoplay: boolean = false;
  public apiConfig: any;
  protected spinDelay: number;
  shouldUpdateBalance: boolean = false;

  constructor() {
    super();
    this.mobile = /Mobi/.test(navigator.userAgent);
    this.android = /android/i.test(navigator.userAgent);
    this.iOS = /(iPad|iPhone|iPod)/i.test(navigator.userAgent);
  }

  public parseUrlParams(urlParams, gameConfig) {
    this.urlParams = urlParams;
    this.lang = urlParams.language || urlParams.lang || urlParams.LanguageCode || "en";
    this.version = urlParams.version || gameConfig.version;
    this.lobbyURL = urlParams.lobbyurl;
    this.regulation = urlParams.regulation || Regulations.Unregulated;
    this.jurisdiction = urlParams.jurisdiction || ' ';
    this.clock = urlParams.clock === "true";
    this.currency = urlParams.currency;
    this.authorizationToken =
      urlParams.authorizationToken || gameConfig.authorizationToken;
    this.operatorToken = urlParams.operatorToken || gameConfig.operatorToken;
    this.playerToken = urlParams.playerToken || gameConfig.playerToken;
    this.sessionID = urlParams.sessionID || gameConfig.sessionID;
    this.isDemo = urlParams.isDemo === "true";
    this.homeUrl = urlParams.homeUrl || urlParams.homeurl;
    this.parseJurisdictionVars(gameConfig);
  }

  parseJurisdictionVars(gameConfig) {
    let parseMinSpinStimeByJurisdictions = gameConfig.PARSE_MIN_SPIN_BY_JURISDICTIONS === undefined ? true : gameConfig.PARSE_MIN_SPIN_BY_JURISDICTIONS
    if (parseMinSpinStimeByJurisdictions && gameConfig.MIN_SPIN_BY_JURISDICTIONS && gameConfig.MIN_SPIN_BY_JURISDICTIONS[this.jurisdiction.toUpperCase()]) {
      gameConfig.minSpinTime = gameConfig.MIN_SPIN_BY_JURISDICTIONS[this.jurisdiction.toUpperCase()];
    }

    if (gameConfig.CASCADE_CONFIG_BY_JURISDICTIONS && gameConfig.CASCADE_CONFIG_BY_JURISDICTIONS[this.jurisdiction.toUpperCase()]) {
      gameConfig.cascadeAnimation = gameConfig.CASCADE_CONFIG_BY_JURISDICTIONS[this.jurisdiction.toUpperCase()]
    }

    // if (gameConfig.disableAutoplayJurisdictions && gameConfig.disableAutoplayJurisdictions.indexOf(this.jurisdiction.toUpperCase()) != -1) {
      // gameConfig.disableAutoplay = true;

    // }

    if (gameConfig.featureBye && gameConfig.featureByeJurisdictionOff?.indexOf(this.jurisdiction.toUpperCase()) != -1) {
      gameConfig.featureBye = false;
    }

    this._gameConfig = { ...gameConfig };
  }

  public get gameConfig() {
    return this._gameConfig;
  }

  public set gameConfig(cfg: any) {
    console.warn("REMOVE GAME CONFIG SETTING FROM INDEX.TS");
  }


  public incrementRestoreVersion() {
    this.restoreVersion++;
  }

  public forceEnableRules(): boolean {
    return this.gameConfig.FORCE_RULES_JURISDICTIONS.indexOf(this.jurisdiction.toUpperCase()) !== -1;
  }

  public isMobile(really: boolean = false): boolean {
    if (!really && this.gameConfig.forceMobile) {
      return true;
    }

    return this.mobile || this.android || this.iOS;
  }

  public setSpinDelay(delay: number) {
    if (delay && delay > 0) {
      this.spinDelay = delay;
    } else {
      this.spinDelay = undefined;
    }
  }

  public getSpinDelay(): number {
    return this.spinDelay || 0;
  }

  public addTurboListener() {
    if (this.canSkipSpin()) {

      KeyboardManager.onKey("pressed", Key.SPACE, this.toggleTurboSpin, this);
      KeyboardManager.onKey("released", Key.SPACE, this.stopTurboSpin, this);
    }
  }

  public removeTurboListener() {
    if (this.canSkipSpin()) {
      KeyboardManager.offKey("pressed", Key.SPACE, this.toggleTurboSpin, this);
      KeyboardManager.offKey("released", Key.SPACE, this.stopTurboSpin, this);
    }
  }

  public toggleTurboSpin() {
    if (this.turboSpin) {
      this.stopTurboSpin();
    } else {
      if (this.canSkipSpin()) {
        this.turboSpin = true;
      }
    }
  }

  public stopTurboSpin() {
    this.turboSpin = false;
  }

  public canSkipSpin(): boolean {
    if (this.gameConfig.NO_SKIP_JURISDICTION && this.gameConfig.NO_SKIP_JURISDICTION.length) {
      return this.gameConfig.NO_SKIP_JURISDICTION.indexOf(this.jurisdiction.toUpperCase()) == -1;
    } else {
      return true;
    }
  }

  public alowSpaceToSkipSpin(): boolean {
    if (this.canSkipSpin()) {
      return this.spaceToSpin;
    }
    return false;
  }

  public getMinSpineTimeByJurisdiction(): number {
    let result = this.gameConfig.minSpinTime;

    if (this.gameConfig.MIN_SPIN_BY_JURISDICTIONS && this.gameConfig.MIN_SPIN_BY_JURISDICTIONS[this.jurisdiction.toUpperCase()]) {
      result = this.gameConfig.MIN_SPIN_BY_JURISDICTIONS[this.jurisdiction.toUpperCase()];
    }

    return result
  }

  public toggleSpaceToSpin() {
    if (this.spaceToSpin) {
      this.spaceToSpin = false;
    } else {
      this.spaceToSpin = true;
    }
  }

  public getLobbyURL(): string {
    return this.lobbyURL || null;
  }
}

export enum Regulations {
  Unregulated = "unregulated",
  UK = "uk",
}

export default new GameModel();
